export default __webpack_public_path__ + "static/Paul-9abbc3922263a1bef78e4c4c24bc6a11.jpeg";